<span class="icomoon icomoon-device-app-id popover-trigger-icon icomoon-table-icon {{getSmsStateClass(sms.state)}}"
      [popover]="outgoingSms" triggers="mouseenter:mouseleave" placement="right"></span>
<ng-template #outgoingSms>
  <div class="d-flex align-items-center">
    <i class="icomoon icomoon-device-app-id popover-icon pr-1 {{getSmsStateClass(sms.state)}}"></i>
    <div class="font-weight-bold">{{'TASK_RECORD_OUTGOING_SMS_STATE' | translate}} </div>
  </div>
  <div class="text-truncate table-text-subtitle mt-1">{{'OUTGOING_SMS_MESSAGE_ID' | translate}}</div>
  <div class="text-truncate">{{sms.messageId}}</div>
  <div
    class="text-truncate table-text-subtitle mt-1">{{'TASK_RECORD_OUTGOING_SMS_STATE' | translate}}</div>
  <div
    class="font-weight-bold break-word">{{getSmsStateKey(sms.state) | translate}}</div>
  <div
    class="text-truncate table-text-subtitle mt-1">{{'OUTGOING_SMS_DELIVERY_TIME' | translate}}</div>
  <div
    class="font-weight-bold break-word">{{sms.deliveryTime?.toUtcIsoString() | date:'short'}} </div>
  <div class="text-truncate table-text-subtitle mt-1">{{'TRIGGER_SMS_INTEGRATION_TYPE' | translate}}</div>
  <div
    class="font-weight-bold break-word">{{getSmsIntegrationTypeKey(sms.integrationType) | translate}}</div>
  <div
    class="text-truncate table-text-subtitle mt-1">{{'TASK_RECORD_OUTGOING_SMS_SEND_MODE' | translate}}</div>
  <div
    class="font-weight-bold break-word">{{getSmsSendModeKey(sms.sendMode) | translate}}</div>
  <ng-container *ngIf="sms.bipState">
    <div class="text-truncate table-text-subtitle mt-1">{{'OUTGOING_SMS_STATE_BIP' | translate}}</div>
    <div class="font-weight-bold break-word">{{sms.bipStateMessage}}</div>
    <div
      class="font-weight-bold break-word">{{sms.bipStateTimestamp?.toUtcIsoString() |
      date:'short'}}</div>
  </ng-container>
</ng-template>
